import { render, staticRenderFns } from "./ArticleEditor.vue?vue&type=template&id=06d6d5b2&scoped=true&"
import script from "./ArticleEditor.vue?vue&type=script&lang=js&"
export * from "./ArticleEditor.vue?vue&type=script&lang=js&"
import style0 from "./ArticleEditor.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ArticleEditor.vue?vue&type=style&index=1&id=06d6d5b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d6d5b2",
  null
  
)

export default component.exports